<!-- 指标统计管理 -->
<template>
  <div class="page">
    <div
      class="paginations"
      :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
    >
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="指标名称：">
            <el-input
              size="small"
              v-model="searchData.statName"
              placeholder="请输入指标名称"
            />
          </el-form-item>
          <el-form-item label="时间：">
            <el-input
              size="small"
              v-model="searchData.statTime"
              placeholder="请输入时间"
            />
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
        </el-form>
        <div class="addition">
          <el-button @click="add">
            添加
            <i class="h_icon icon-add"></i>
          </el-button>
          <el-button @click="cutOut(true)">批量删除</el-button>
          <el-button @click="execute(selectRows, false)">
            执行
            <i class="h_icon icon-edit" />
          </el-button>
        </div>
      </div>

      <div class="table_box">
        <el-table
          :data="tableObj.list"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="statName" label="指标名称" align="center" />
          <el-table-column prop="statTime" label="时间" align="center" />
          <el-table-column prop="percent" label="进度" align="center" />
          <el-table-column prop="statStatus" label="状态" align="center" />
          <el-table-column prop="zykIdsNum" label="异常资源库数" align="center">
            <template slot-scope="scope">
              <span
                @click="cellClick(scope.row)"
                style="
                  cursor: pointer;
                  text-decoration: underline;
                  color: #1bf6f8;
                "
                >{{ scope.row.zykIdsNum }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <i
                class="icona el-icon-view"
                title="查看日志"
                @click="viewLog(scope.row)"
              ></i>
              <i
                class="icona el-icon-document"
                title="执行"
                @click="execute(scope.row, true)"
              />
              <i
                class="icona icon-edit"
                title="编辑"
                @click="edit(scope.row)"
              />
              <i
                class="icona icon-delete"
                title="删除"
                @click="cutOut(false, [scope.row.id])"
              />
            </template>
          </el-table-column>
        </el-table>
        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :page-size="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="uploadBox.title"
      :visible.sync="uploadBox.show"
      :close-on-click-modal="false"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
      @opened="opened"
    >
      <el-form
        ref="uploadBox"
        :model="uploadBox.data"
        :rules="uploadBox.rules"
        label-width="88px"
      >
        <el-form-item label="指标名称：" prop="statName">
          <el-input
            size="small"
            v-model="uploadBox.data.statName"
            placeholder="请输入指标名称"
            @input="inputChange"
          />
        </el-form-item>
        <el-form-item label="时间：" prop="statTime">
          <el-input
            size="small"
            v-model="uploadBox.data.statTime"
            placeholder="请输入时间"
            @input="inputChange"
          />
        </el-form-item>
        <el-form-item label="接口：" prop="url">
          <el-input
            size="small"
            type="textarea"
            v-model="uploadBox.data.url"
            placeholder="请输入接口"
            style="font-family: initial"
            @input="inputChange"
          />
        </el-form-item>
        <el-form-item label="级别：" prop="projectType">
          <el-radio-group
            v-model="uploadBox.data.projectType"
            @input="radioInput"
          >
            <el-radio :label="1">国家级</el-radio>
            <el-radio :label="2">省级</el-radio>
            <el-radio :label="3">校级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="资源库：" prop="api">
          <el-button size="small" @click="selectZyk">选择</el-button>
        </el-form-item>
        <div class="zyk-content">
          <span class="item" v-for="(item, index) in checkNodes" :key="index"
            >{{ index + 1 }}、{{ item.zykName }}</span
          >
        </div>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="选择资源库"
      :visible.sync="showZykTree"
      :close-on-click-modal="false"
      class="pop_up"
      append-to-body
      :before-close="treeClose"
    >
      <el-tree
        :data="zykDataList"
        :props="props"
        node-key="zykId"
        ref="zykTree"
        default-expand-all
        show-checkbox
        :default-checked-keys="defaultCheckNode"
      >
      </el-tree>
      <div class="tx-center">
        <el-button size="small" @click="treeSure">确定</el-button>
        <el-button size="small" @click="treeClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      // 查询条件
      searchData: {
        statName: "",
        statTime: "",
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      optId: "", //判断当前是修改还是新增操作 1-新增；2-修改
      // 新增弹窗
      uploadBox: {
        show: false,
        title: "",
        data: {
          id: null,
          indexName: "", //指标名称
          time: "", //时间
          api: "", //接口
          zykIds: [],
          projectType: 1,
        },
        rules: {},
      },
      showZykTree: false, //是否显示树弹框
      props: {
        label: "zykName",
        children: "children",
      },
      // 树结构数据
      zykDataList: [
        {
          zykName: "全选/反选",
          children: [],
        },
      ],
      defaultCheckNode: [], //树结构默认选中的节点
      checkNodes: [], //选中的树节点对象
      zykIdsArr: [],
      selectRows: [], //选中行的zykId数组
      selectRowId: [],
    };
  },
  mounted() {
    // 初始化
    this.$store.commit("modifyVague", false);
    this.search();
  },
  methods: {
    inputChange(){
      this.$forceUpdate()
    },
    radioInput(val) {
      this.getAllZykList(val, []);
    },
    getAllZykList(data, checkKeys) {
      this.$axios
        .post(this.$apiurls.major_getAllZykList, data, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.zykDataList[0].children = res.data;
            if (checkKeys) {
              this.defaultCheckNode = checkKeys;
              let newArr = [];
              for (const item of res.data) {
                for (const val of checkKeys) {
                  if (item.zykId === val) {
                    newArr.push(item);
                  }
                }
              }
              this.checkNodes = newArr;
            }
          }
        });
    },
    // 查询表格
    search(page) {
      this.searchData.pageDto.pageNum = page ? page : 1;
      this.tableObj.jumpTo = page ? page : 1;
      this.$axios
        .post(this.$apiurls.getStatManageInfo, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.list;
            for (const item of data) {
              item.zykIdsNum = item.zykIds.split(",").length;
            }
            this.tableObj.list = data;
            this.tableObj.total = res.data.total;
          }
        });
    },
    // 重置表格
    reset() {
      this.searchData.statName = "";
      this.searchData.statTime = "";
      this.search();
    },
    // 表格多选
    handleSelectionChange(val) {
      this.selectRows = val;
      let idArr = [];
      for (const item of val) {
        idArr.push(item.id);
      }
      this.selectRowId = idArr;
    },
    // 点击删除按钮
    cutOut(flag, id) {
      let str = "";
      if (flag) {
        str = "此操作将永久删除选中指标, 是否继续?";
        if (this.selectRowId.length === 0)
          return this.$message.warning({
            message: "请先选择要批量删除的行！",
          });
        id = this.selectRowId;
      } else str = "此操作将永久删除该指标, 是否继续?";
      this.$store.commit("modifyVague", true);
      this.$confirm(str, "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$axios
            .post(this.$apiurls.delStatManageInfo, id, {
              loading: false,
            })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "删除成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
            });
        })
        .catch(() => {
          this.uploadBox.show = false;
          this.$store.commit("modifyVague", false);
        });
    },
    // 点击编辑按钮
    edit(row) {
      for (const key in row) {
        this.uploadBox.data[key] = row[key];
      }
      this.optId = "2";
      this.uploadBox.title = "修改指标";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      let zykIds = row.zykIds ? row.zykIds.split(",") : [];
      this.zykIdsArr = zykIds;
      this.getAllZykList(row.projectType, zykIds); //默认渲染国家级数据
    },
    // 点击新增按钮
    add() {
      // 每次新增打开弹框前都先清除之前的表单数据
      for (const key in this.uploadBox.data) {
        if (key === "id") this.uploadBox.data[key] = null;
        else if (key === "projectType") this.uploadBox.data[key] = 1;
        else this.uploadBox.data[key] = "";
      }
      this.getAllZykList(1); //默认渲染国家级数据
      this.optId = "1";
      this.uploadBox.title = "添加指标";
      this.checkNodes = [];
      if (this.$refs.zykTree) this.$refs.zykTree.setCheckedKeys([]);
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
    },
    // 异常资源库数点击
    cellClick(item) {
      this.$alert(
        item.zykIds
          ? item.zykIds
          : `<p style='text-align:center;color:gray;'>暂无资源库</p>`,
        `查看异常资源库`,
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
    // 点击查看日志
    viewLog(item) {
      this.$alert(
        item.logText
          ? item.logText
          : `<p style='text-align:center;color:gray;'>暂无日志信息</p>`,
        `查看日志 - ${item.statName}`,
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
    // 点击执行按钮
    execute(val, flag) {
      let params = [];
      if (flag) {
        params.push({
          id: val.id,
          zykIds: val.zykIds.split(","),
          url: val.url,
          projectType: val.projectType,
        });
      } else
        for (const item of val) {
          params.push({
            id: item.id,
            zykIds: item.zykIds.split(","),
            url: item.url,
            projectType: item.projectType,
          });
        }
      if (!flag && val.length === 0)
        return this.$message.warning({
          message: "请先选择要执行的行！",
        });
      this.$axios
        .post(this.$apiurls.executeStat, params, { loading: false })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "执行成功",
              type: "success",
            });
            this.search();
          }
        });
    },
    // 选择资源库弹出树
    selectZyk() {
      this.showZykTree = true;
      this.uploadBox.show = false;
    },
    // 树弹框点击确定
    treeSure() {
      let arr = this.$refs.zykTree.getCheckedNodes();
      arr = arr.filter((item) => item.zykName != "全选/反选");
      this.checkNodes = arr;
      this.zykIdsArr = this.$refs.zykTree.getCheckedKeys();
      this.showZykTree = false;
      this.uploadBox.show = true;
    },
    // 关闭树弹框
    treeClose() {
      this.showZykTree = false;
      this.uploadBox.show = true;
    },
    // 新增/修改弹框打开
    opened() {
      this.$refs.uploadBox.clearValidate();
    },
    // 关闭新增/修改弹框
    handleClose() {
      this.uploadBox.show = false;
      this.$store.commit("modifyVague", false);
      this.optId = "";
    },
    // 添加/修改院校请求接口
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          let url =
            this.optId === "1"
              ? this.$apiurls.addStatManageInfo
              : this.optId === "2"
              ? this.$apiurls.editStatManageInfo
              : "";
          if (!url) return;
          this.uploadBox.data.zykIds = this.zykIdsArr.join(",");
          this.$axios
            .post(url, this.uploadBox.data, {
              loading: false,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: this.optId === "2" ? "编辑成功！" : "添加成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
              this.optId = "";
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}
.addition{
  margin-top: 5px;
}
// 搜索
.table-search-box-hander {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-form {
  height: 100%;
  .el-textarea {
    .el-textarea__inner {
      font-family: initial;
    }
  }
}
.pop_up ::v-deep .el-dialog__body {
  max-height: 600px;
}
.el-tree {
  max-height: 550px;
  overflow: auto;
}
.el-tree,
::v-deep.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content,
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}

.table_box {
  // max-height: calc(100% - 60px);
  margin-bottom: 0;
}
</style>
<style lang="scss">
.zyk-content {
  width: calc(100% - 50px);
  margin-left: 20px;
  min-height: 100px;
  max-height: 200px;
  overflow: auto;
  border: 1px solid rgba(86, 94, 121, 0.59);
  background-color: rgba(86, 94, 121, 0.59);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 15px;
  .item {
    margin-right: 20px;
    color: #fff;
  }
}
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;
    .el-select-dropdown__item {
      color: #fff !important;
    }
    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }
    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }
    .selected {
      color: rgba(27, 246, 248);
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}
.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}
.el-icon-view,
.el-icon-document {
  font-size: 18px;
  color: #1bf6f8;
  margin-right: 5px;
  cursor: pointer;
}
.el-message-box .el-message-box__btns .el-button:last-child {
  margin: 0;
}
.el-message-box .el-message-box__btns .el-button:nth-child(1) {
  margin-left: 15px;
}
.el-message-box__message p {
  line-height: 30px;
  color: #fff;
  word-break: normal;
  white-space: normal;
  word-wrap: break-word;
}
.el-message-box ::-webkit-scrollbar {
  width: 5px;
  border-radius: 4px;
}
.el-message-box ::-webkit-scrollbar-track {
  background-color: #081338;
}
.el-message-box ::-webkit-scrollbar-thumb {
  background-color: #3b466e;
}
</style>
